jQuery( document ).ready(function() {
    if( jQuery('section.therapeutic-areas').length ) {
        
        // Toggle disease details
        jQuery('.disease').on('click', '.disease-info-toggle', function () {
            jQuery(this).parents('.disease').toggleClass('collapsed');
        });
        
    }
});